/**
 * Inline SVG icons for the builder. The codebase has no shared icon set — Brand/ThemeToggle in
 * @huaca/ui inline their SVGs the same way — so these live next to the only screen that uses them.
 *
 * Both are `currentColor` and `aria-hidden`: the accessible name lives on the wrapping <button>
 * (`aria-label`), so the glyph itself must not be announced twice.
 */

/** Six-dot drag grip — the standard "grab me" affordance for a sortable row. */
export function GripIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false">
      <circle cx="5.5" cy="3.5" r="1.4" />
      <circle cx="10.5" cy="3.5" r="1.4" />
      <circle cx="5.5" cy="8" r="1.4" />
      <circle cx="10.5" cy="8" r="1.4" />
      <circle cx="5.5" cy="12.5" r="1.4" />
      <circle cx="10.5" cy="12.5" r="1.4" />
    </svg>
  );
}

/** Trash can — the delete affordance. Stroked to read as a light, secondary control. */
export function TrashIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M2.5 4h11" />
      <path d="M6 4V2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75V4" />
      <path d="M4 4l.6 8.4A1.5 1.5 0 0 0 6.1 14h3.8a1.5 1.5 0 0 0 1.5-1.6L12 4" />
      <path d="M6.5 7v4M9.5 7v4" />
    </svg>
  );
}
